import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { LoginComponent } from './login.component';
import { NotFoundComponent } from './not-found.component';


import { ElementsModule } from '../elements.component.module/elements.module';
import { CommonModule } from '@angular/common';
import { LogoutComponent } from './logout.component';

@NgModule({
    declarations: [
        LoginComponent,
        LogoutComponent,
        NotFoundComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ElementsModule,
    ],
    exports: [
        LoginComponent,
        LogoutComponent,
        NotFoundComponent
    ],
    bootstrap: [],
})
export class KpCommonModule {
}
